import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Form, Modal, notification } from 'antd';

import { ReactComponent as IconClose } from 'assets/images/close.svg';
import { undoCancelledTransactions } from 'services/api/module/booking.api';
import useModal from 'stores/useModal';
import QUERY_KEYS from 'services/api/queryKeys';
import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';

function UndoCancelledTransactions() {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const {
    undoCancelledTransactions: { cancelled_transaction_ids, isOpenUndoCancelledTransactions },
    closeUndoCancelledTransactions
  } = useModal();
  const { mutateAsync: mutateUndoCancelledTransactions, isPending } = useMutation({
    mutationFn: ({ cancelled_transaction_ids }: { cancelled_transaction_ids: number[] }) =>
      undoCancelledTransactions({ cancelled_transaction_ids })
  });

  const handleCloseUndoCancelledTransactions = () => {
    closeUndoCancelledTransactions();
    form.resetFields();
  };

  const handleUndoCancelledTransactions = async () => {
    try {
      await mutateUndoCancelledTransactions({
        cancelled_transaction_ids: cancelled_transaction_ids
      });
      closeUndoCancelledTransactions();
      form.resetFields();
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_GUEST_TRANSACTIONS, QUERY_KEYS.GET_GUEST_TRANSACTIONS_DETAIL]
      });
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_GUEST]
      });
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_TRANSACTION_HISTORY_LOGS]
      });
      notification.success({
        message: t('common.message.undoCancelledTransaction')
      });
    } catch (err: any) {
      notification.error({
        message: err.error || t('common.error')
      });
    }
  };

  return (
    <Modal
      title={t('cashierPage.undoCancelledTransaction.title')}
      centered
      width={410}
      open={isOpenUndoCancelledTransactions}
      onCancel={handleCloseUndoCancelledTransactions}
      closeIcon={<IconClose />}
      okText={t('cashierPage.undoCancelledTransaction.submitButton')}
      cancelText={t('common.actions.cancel')}
      onOk={handleUndoCancelledTransactions}
      okButtonProps={{ className: 'ant-btn-secondary' }}
      className="modal-cancel-transactions"
      destroyOnClose
      confirmLoading={isPending}
    ></Modal>
  );
}

export default UndoCancelledTransactions;
